<div class="custom-objects-result">
  @if (!customObjectsEnabled()) {
    <ui-no-data [title]="'CUSTOM_OBJECTS_RESULT.FEATURE_DISABLED' | translate"></ui-no-data>
  } @else if (!response()) {
    <div class="custom-objects-result__loading">
      <ui-preloader [color]="preloaderColor.blue"></ui-preloader>
    </div>
  } @else if (!totalCount()) {
    <ui-no-data
      [imgSrc]="noData.imgSrc"
      [title]="noData.title | translate"
      [description]="noData.description | translate"
      [createButtonText]="noData.createButtonText | translate"
      (onCreate)="createCustomObject()"
    ></ui-no-data>
  } @else {
    <div class="custom-objects-result__toolbar">
      <ui-search
        [placeholder]="'CUSTOM_OBJECTS.SEARCH_PLACEHOLDER' | translate"
        [searchQuery]="searchQuery()"
        (onInput)="onSearchQuery($event)"
      ></ui-search>
      <ui-button
        type="primary"
        [text]="'CUSTOM_OBJECTS.CREATE_CUSTOM_OBJECT' | translate"
        (clickAction)="createCustomObject()"
      ></ui-button>
    </div>

    <!-- The count line reports the unfiltered total, exactly like the page. -->
    <div class="custom-objects-result__count">
      {{ 'CUSTOM_OBJECTS_RESULT.COUNT' | translate: { count: totalCount() } }}
    </div>

    @if (!listItems().length) {
      <ui-no-data [title]="'CUSTOM_OBJECTS.NO_RESULTS' | translate"></ui-no-data>
    } @else {
      <div class="custom-objects-result__grid">
        @for (listItem of listItems(); track listItem.key) {
          <ui-custom-object-state-card
            [customObject]="listItem.item"
            [showActions]="true"
            (editName)="editName(listItem.item)"
            (remove)="remove(listItem.item)"
          ></ui-custom-object-state-card>
        }
      </div>
    }
  }
</div>
